/**
 * The two LLM-facing bindings the Projects agent config exposes for
 * the Evidence sub-agent. Both route to the inline block.
 */
export const ANSWER_WITH_EVIDENCE_TOOL_NAME = 'answer_with_evidence';
export const LOOKUP_EVIDENCE_TOOL_NAME = 'lookup_evidence';

export const EVIDENCE_SUBAGENT_TOOL_NAMES = new Set<string>([
  ANSWER_WITH_EVIDENCE_TOOL_NAME,
  LOOKUP_EVIDENCE_TOOL_NAME,
]);

export const isEvidenceSubagentToolName = (name: string | undefined): boolean =>
  name !== undefined && EVIDENCE_SUBAGENT_TOOL_NAMES.has(name);

/**
 * Pull the `question` argument out of a tool_call's input so the inline block
 * can show it as a placeholder before the first SSE chunk lands. Mirrors the
 * readers in `EvidenceConsultBlock` / `ComputerUseTaskBlock`.
 */
export const readEvidenceSessionInput = (
  input: Record<string, unknown> | undefined
): { question?: string } => {
  if (!input) return {};
  const question =
    typeof input.question === 'string' && input.question.trim()
      ? input.question.trim()
      : undefined;
  return { question };
};
